<template>
  <v-text-field 
    ref="it"
    :dense="disabled"
    :readonly="disabled"
    :flat="disabled"
    :filled="disabled"
    :prepend-icon="extlink ? 'mdi-open-in-new' : ''"
    @click:prepend="follow_ext"
    :append-icon="copyvalue ? is_copied ? 'mdi-check-underline' : 'mdi-content-copy' : ''"
    @click:append="copyit"
    color="green"
    :value="value"
    @input="$emit('input', $event)"
  
    v-bind="$attrs"
  >

  </v-text-field>
</template>

<script>
export default {
  props:{
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    copyvalue:{
      type: Boolean,
      default: false
    },
    extlink: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    is_copied: false
  }),
  methods:{
    copyit(){
      let el = this.$refs.it.$refs.input // document.getElementById('link_input')      
      el.select()      
      document.execCommand('copy')
      el.blur()
      this.is_copied = true
      setTimeout(() => this.is_copied = false, 1000)
    },
    follow_ext(){
      window.open(this.extlink, '_blank');
    }
  }
}
</script>

